export { TrustpilotMicroReviewWidget } from './trustpilot-micro-review-widget';
